import { useMemo, useCallback } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useUserSettings } from 'src/hooks';
import { getTimeZoneShortName } from 'src/utils';
import { SettingKeys, SingleSelectSetting } from 'src/types';

dayjs.extend(utc);
dayjs.extend(timezone);

export const useTimeZone = () => {
  const { setting } = useUserSettings<SingleSelectSetting>(
    SettingKeys.MANUALLY_SELECTED_TIMEZONE,
  );

  const userTimeZone = useMemo(
    () => setting?.value || dayjs.tz.guess(),
    [setting?.value],
  );

  const convertUTCtoUserTimeZone = useCallback(
    (date: Dayjs | string) => {
      return dayjs(date).tz(userTimeZone);
    },
    [userTimeZone],
  );

  const convertUserTimeZoneToUTC = useCallback((date: Dayjs | string) => {
    return dayjs(date).utc();
  }, []);

  return {
    convertUTCtoUserTimeZone,
    convertUserTimeZoneToUTC,
    userTimeZone,
    userTimeZoneShortName: getTimeZoneShortName(userTimeZone),
  };
};
